import FontSizeChanger from './components/fontSizeChanger/index';
import './styles/main.scss';

export default FontSizeChanger;
